import React, { useEffect, useState } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import { doc, getDoc } from "firebase/firestore"
import { useParams } from "react-router-dom"
import { db } from '../../../firebase'

const Single = ({user}) => {

  const {messageId} = useParams()


  const [ messageData, setMessageData ] = useState("")

  // const [ orderData, setOrderData ] = useState([])

  const getMessage = async() => {

      const docRef = doc(db, "messages", messageId);

      const docSnap = await getDoc(docRef);

    
      
      if (docSnap.exists()) {

        setMessageData(docSnap.data())
        // console.log(userData)
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
  }

  useEffect(()=>{

    getMessage()
    
  }, [])


  return (
    <div className='single'>
      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>
        <div className="top">
          <div className="left">
            <div style={{display: 'flex', flexDirection:'row', alignItems:'center', gap:20, marginLeft:20}}>
            <h2 className='title'>Message Information</h2>
            

            </div>
            <div className='item'>
       
                <div className="details">
                  <h3 className='itemTitle'>{messageData.date}</h3>

                   <div className='detailItem'>
                    <span className='itemKey'>Status:</span>
                    <span className='itemValue'>{messageData.status}</span>
                  </div>
                 
                  <div className='detailItem'>
                    <span className='itemKey'>Subscriber Plan:</span>
                    <span className='itemValue'>{messageData.plan}</span>
                  </div>
                  
                 

                   <div className='detailItem'>
                    <span className='itemKey'>Title:</span>
                    <span className='itemValue'>{messageData.title}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Message:</span>
                    <span className='iitemValue'>{messageData.message}</span>
                  </div>
                </div>
            </div>
          </div>
        
        </div>
      
      </div>
    </div>
  )
}

export default Single